module.exports = __webpack_public_path__ + "img/phone-random.66f6944f.webp";